import { render, staticRenderFns } from "./OrganizationSetting.vue?vue&type=template&id=d794d048&scoped=true&"
import script from "./OrganizationSetting.vue?vue&type=script&lang=js&"
export * from "./OrganizationSetting.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSetting.vue?vue&type=style&index=0&id=d794d048&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d794d048",
  null
  
)

export default component.exports